import React from 'react';
import { Stack, Typography } from '@mui/material';
import './Footer.scss';

const Footer: React.FC = () => {
    return (
        <div className='footer'>
            <footer>
                <Stack
                    data-testid="footer-stack">
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{
                            fontSize: '11px',
                            fontFamily: 'AS Circular',
                            fontWeight: 'bold',
                            color: '#939fad'
                        }}
                    >
                        Copyright @{new Date()?.getFullYear()?.toString()}, Alaska Air Group
                    </Typography>
                </Stack>
            </footer>
        </div>
    );
};

export default Footer;